<template>
  <div class="school content">
     <div class="head">
        院校排行榜
     </div>

     <el-table :data="list" border style="width: 1000px;margin: 0 auto;margin-top: 30px;" :header-cell-style="{background:'#f5f5f5'}" v-loading="loading">
       <el-table-column label="排名" align="center" width="80">
         <template slot-scope="scope">
           {{
             scope.$index+1
           }}
         </template>
       </el-table-column>
       <el-table-column label="院校名称" align="center">
         <template slot-scope="scope">
           {{
             scope.row.collegeName
           }}
         </template>
       </el-table-column>
       <el-table-column label="所在地区" align="center" width="120">
         <template slot-scope="scope">
           {{
             scope.row.collegeProvince
           }}
         </template>
       </el-table-column>
       <el-table-column label="综合得分" align="center" width="100">
         <template slot-scope="scope">
           {{
             scope.row.ruan_pai
           }}
         </template>
       </el-table-column>
       <el-table-column label="办学层次" align="center" width="120">
         <template slot-scope="scope">
           {{
             scope.row.collegeLevel
           }}
         </template>
       </el-table-column>
     </el-table>
  </div>
</template>

<script>
  import { paiListColl } from "@/api/gw/major.js"
  export default {
    data(){
      return{
        loading:false,
        list:[],
      }
    },
    mounted(){
      this.paiListColl();
    },
    methods:{
      paiListColl(){
        this.loading = false
        paiListColl({}).then(res=>{
          console.log("院校排行",res.data);
          this.list = res.data
        }).finally(()=>{
          this.loading = false
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .sch-level{
    margin-top: 10px;
    color: #666666;
        height: 22px;
        display: flex;
        align-items: center;
        width: fit-content;
  }
  .lists{
    width:100%;
    display: flex;
    flex-wrap: wrap;
    .item-depart-title{
      color: #999999;
    }
    .col-line{
          color: #E7E7E7;
              padding: 0 10px;
    }
    .address{
      margin-top: 7px;
      color: #666666;
          height: 22px;
          display: flex;
          align-items: center;
          width: fit-content;
          .dingwei{
            width: 20px;
            height: 20px;
            margin-right:5px;
          }
    }
    .listcon{
      .info-box{
        flex: 1;
        font-size: 14px;
        .sch-title{
              display: flex;
              align-items: center;
              justify-content: space-between;
                  font-size: 16px;
                  line-height: 26px;
                  height: 26px;
        }
      }
      .logo{
            display: block;
            width: 68px;
            height: 68px;
            margin-right: 16px;
            img{
              width:100%;
              height: 100%;
              border-radius: 50%;
            }
      }
          box-sizing: border-box;
          padding: 20px 29px 22px;
          display: flex;
          align-items: center;
          width: calc(50% - 10px);
          background: #FFFFFF;
          margin-top: 20px;
          position: relative;
          margin-bottom: 20px;
    }
    .listcon:nth-child(2n){
      margin-left: auto;
    }
  }
  .list{
    width:1250px;
    margin:0 auto;
    min-height: 300px;
  }
  .item-options{
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        color: #333333;
  }
  .span{
    margin-right: 20px;margin-bottom: 10px;cursor: pointer;
  }
  .spanselect{
    color: #1CB278!important;
    font-weight: bold;
  }
  .span:hover{
    color: #1CB278!important;
  }
  .pri01{
    width: 84px;

    margin-right: 22px;
    color: #7B7B7B;
  }
  .pro{
    display: flex;
    flex-wrap: wrap;
  }
  .yuanxiaoku-sch-list-page{
    .yuanxiaoku-sch-list-pages{
      width: 1180px;
      margin: 0 auto;
    }
      width:1250px;
      margin: 0 auto;
      padding-top: 20px;
      padding-bottom: 20px;
      background: #FFFFFF;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
  }
.school{
  width: 100%;
  .head{
    width: 100%;
    height: 148px;
    background: linear-gradient(180deg,#49c48d,#1cb278);
    background: url(../../assets/yuanxiaoku.jpg) no-repeat;
    background-size: 100%;
    line-height: 148px;
    text-align: center;
    font-size: 38px;
    font-weight: 600;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/school/ranking.vue